'use strict';

bbw.service.GrowlSvc = Class({

    $inject: ['inform'],

    _inform: undefined,

    ICON_CLASS_MAP: {
        danger: 'fa fa-minus-circle',
        warning: 'fa fa-exclamation-circle',
        info: 'fa fa-info-circle',
        success: 'fa fa-check-circle'
    },

    construct: function(inform) {
        this._inform = inform;
    },

    error: function(msg) {
        this.add(msg, {type: "danger"});
    },

    warn: function(msg) {
        this.add(msg, {type: "warning"});
    },

    info: function(msg) {
        this.add(msg, {type: "info"});
    },

    success: function(msg) {
        this.add(msg, {type: "success"});
    },

    add: function(msg, params) {
        var tplArgs;
        if (angular.isArray(msg)) {
            tplArgs = msg;
            msg = tplArgs.shift();
        }
        if (angular.isObject(msg)) {
            if (!msg.error) {
                return;
            }
            if (angular.isArray(msg.error_params)) {
                tplArgs = msg.error_params
            }
            msg = msg.error;
        }
        var text = bbw.messages[msg] || msg || bbw.messages.internal_error || 'Internal Error';
        if (tplArgs) {
            for (var i = 0; i < tplArgs.length; ++i) {
                if (angular.isString(tplArgs[i]) && tplArgs[i].charAt(0) == '$') {
                    var tplArgValue = ngtk.tools.object.getByPath(bbw.messages, tplArgs[i].substr(1));
                    if (tplArgValue) {
                        tplArgs[i] = tplArgValue;
                    }
                }
            }
            tplArgs.unshift(text);
            text = ngtk.tools.string.format.apply(null, tplArgs);
        }
        params = params || {};
        params.iconClass = params.type ? this.ICON_CLASS_MAP[params.type] : undefined;
        this._inform.add(text, params);
    }

});
